









import {Vue, Component, Prop, Emit, Model, Watch} from 'vue-property-decorator';

@Component({
  name: 'MyTabs',
})
export default class MyTabs extends Vue {
  @Prop() tabs: Array;
  @Prop({
    default: 'row'
  })
  direction: string;

  @Model('change')
  tabActive: string

  @Emit('change')
  emitChange(newValue: any): void {
  }

  get tabActiveIndex(): number {
    for(const index in this.tabs) {
      if( this.tabs[index] === this.tabActive) {
        return Number(index);
      }
    }
    return 0;
  }

  changeTab(item) {
    this.emitChangeTab(item);
  }

  @Emit('changeTab')
  emitChangeTab(newValue: any): void {
  }
}
